<template>

  <div class="menu-title">
    <p>Noodle Dish</p>
  </div>


  <div class="menu-sub-title">
    <p>Ramen (라면)</p>
  </div>


  <div class="noodle-container-1">

    <div class="noodle-grid-1">
      <div>
        <img class="menu-pic" src="../assets/Ramen.jpg">
      </div>
      <div class="menu-text">
        <p>Jin Mild (진라면)</p>
        <!-- <p>7.99</p> -->
      </div>
    </div>

    <div class="noodle-grid-2">
      <div>
        <img class="menu-pic" src="../assets/Ramen.jpg">
      </div>
      <div class="menu-text">
        <p>Jin Spicy (매운진)</p>
        <!-- <p>7.99</p> -->
      </div>
    </div>

    <div class="noodle-grid-3">
      <div>
        <img class="menu-pic" src="../assets/Ramen.jpg">
      </div>
      <div class="menu-text">
        <p>Tofu Ramen (두부라면)</p>
        <!-- <p>9.99</p> -->
      </div>
    </div>
  </div>


  <div class="noodle-container-2">

    <div class="noodle-grid-4">
      <div>
        <img class="menu-pic" src="../assets/DumplingSoup.jpg">
      </div>
      <div class="menu-text">
        <p>Dumpling Ramen</p>
        <!-- <p>12.99</p> -->
      </div>
    </div>
  </div>


  <div class="menu-sub-title">
    <p>Udon (우동)</p>
  </div>


  <div class="noodle-container-3">

    <div class="noodle-grid-5">
      <div>
        <img class="menu-pic" src="../assets/UdonVeggie.jpg">
      </div>
      <div class="menu-text">
        <p>Veggie Tofu (야채두부)</p>
        <!-- <p>7.99</p> -->
      </div>
    </div>

    <div class="noodle-grid-6">
      <div>
        <img class="menu-pic" src="../assets/UdonVeggie.jpg">
      </div>
      <div class="menu-text">
        <p>Beef (소고기)</p>
        <!-- <p>13.99</p> -->
      </div>
    </div>
       
    <div class="noodle-grid-7">
      <div>
        <img class="menu-pic" src="../assets/UdonVeggie.jpg">
      </div>
      <div class="menu-text">
        <p>Pork (돼지고기)</p>
        <!-- <p>11.99</p> -->
      </div>
    </div>
  </div>


  <div class="noodle-container-4">

    <div class="noodle-grid-8">
      <div>
        <img class="menu-pic" src="../assets/UdonVeggie.jpg">
      </div>
      <div class="menu-text">
        <p>Shrimp (새우)</p>
        <!-- <p>13.99</p> -->
      </div>
    </div>

  </div>


  <div class="menu-sub-title">
    <p>Jjajang (Black Bean Paste Noodle, 짜장)</p>
  </div>


  <div class="noodle-container-5">

    <div class="noodle-grid-9">
      <div>
        <img class="menu-pic" src="../assets/Jjajang.jpg">
      </div>
      <div class="menu-text">
        <p>Veggie (야채짜장)</p>
        <!-- <p>11.99</p> -->
      </div>
    </div>  

    <div class="noodle-grid-10">
      <div>
        <img class="menu-pic" src="../assets/Jjajang.jpg">
      </div>
      <div class="menu-text">
        <p>Pork (돼지고기 짜장)</p>
        <!-- <p>13.99</p> -->
      </div>
    </div>
    
    <div class="noodle-grid-11">
      <div>
        <img class="menu-pic" src="../assets/Jjajang.jpg">
      </div>
      <div class="menu-text">
        <p>Beef (소고기 짜장)</p>
        <!-- <p>14.99</p> -->
      </div>
    </div>
    
  </div>


  <div class="menu-sub-title">
    <p>Jjampong (Seafood Noodle, 짬뽕)</p>
  </div>


  <div class="noodle-container-6">

    <div class="noodle-grid-12">
      <div>
        <img class="menu-pic" src="../assets/Jjampong.jpg">
      </div>
      <div class="menu-text">
        <p>Spicy Jjampong (매운)</p>
        <!-- <p>14.99</p> -->
      </div>
    </div>  

    <div class="noodle-grid-13">
      <div>
        <img class="menu-pic" src="../assets/Jjampong.jpg">
      </div>
      <div class="menu-text">
        <p>Mild Jjampong (순한)</p>
        <!-- <p>14.99</p> -->
      </div>
    </div>  
  </div>


  <div class="menu-sub-title">
    <p>Kalkuksu (Knife-Cut Noodle, 칼국수)</p>
  </div>


  <div class="noodle-container-7">

    <div class="noodle-grid-14">
      <div>
        <img class="menu-pic" src="../assets/NaengMyun.jpg">
      </div>
      <div class="menu-text">
        <p>Veggie</p>
        <!-- <p>9.99</p> -->
      </div>
    </div>
    
    <div class="noodle-grid-15">
      <div>
        <img class="menu-pic" src="../assets/NaengMyun.jpg">
      </div>
      <div class="menu-text">
        <p>Seafood</p>
        <!-- <p>13.99</p> -->
      </div>
    </div>
  </div>


  <div class="menu-sub-title">
    <p>NaengMyun (Cold Noodle, 냉면)</p>
  </div>


  <div class="noodle-container-8">

    <div class="noodle-grid-6">
      <div>
        <img class="menu-pic" src="../assets/NaengMyun.jpg">
      </div>
      <div class="menu-text">
        <p>NaengMyun (냉면)</p>
        <!-- <p>11.99</p> -->
      </div>
    </div>  
  </div>

</template>


<script>

  export default {
    name: 'ComboBody'
  }

</script>



<style scoped>

/* for desktop */
@media (min-width:701px) {

  .menu-title {
    text-align: center;
    font-size: 4vw;
    font-weight: bold;
    line-height: 0.5vw;
    margin-bottom: 5vw;
    color: darkblue;
  }


  .menu-sub-title {
    display: inline-flex;
    float: left;
    border: 2px solid darkblue;
    background-color: rgb(255,204,211);
    color: darkblue;
    height: 2.2rem;
    line-height: 1rem;
    align-items: center;
    justify-content: center;
    font-size: 1.7rem;
    font-weight: bold;
    margin-top: 1vw;
    margin-left: 6vw;
  }

  .noodle-container-1, .noodle-container-2, .noodle-container-3, .noodle-container-4, .noodle-container-5, .noodle-container-6, .noodle-container-7, .noodle-container-8 {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    width: 100%;
    height: 28vw;
    margin-top: 0.5vw;
    background-color: rgb(250,250,250);
  }    
  
  .menu-pic {
    width: 22vw;
    height: 18vw;
    margin-top: 1vw;
    margin-left: 1.5vw;
  }

  .menu-text {
    text-align: center;
    color: darkblue;
    font-style: optima;
    font-size: 2vw;
    font-weight: bold;
    line-height: 0.5vw;
    margin-top: -0.5vw;
    margin-left: 1.7vw;
  }

}


/* for Phone */
@media (max-width:700px) {

  .menu-title {
    text-align: center;
    font-size: 5vw;
    font-weight: bold;
    line-height: 2vw;
    margin-top: -1vw;
    margin-bottom: 2rem;
    color: darkblue;
  }

  .menu-sub-title {
    text-align: center;
    text-decoration: underline;
    font-size: 1.5rem;
    font-weight: bold;
    line-height: 0.5vw;
    margin-top: 3rem;
    margin-left: 1rem;
    color: darkblue;
  }


  .menu-pic {
    width: 15rem;
    height: auto;
    margin-top: 4vw;
  }
  
  .menu-text {
    text-align: center;
    color: darkblue;
    font-style: optima;
    font-size: 1.2rem;
    font-weight: bold;
    line-height: 0.3rem;
    margin-top: -0.5vw;
  }

}
  
</style>